var map = {
	"./C.png": "8b57",
	"./Group 1.png": "02a6",
	"./Group 2.png": "987c",
	"./LMS_LOGO.png": "e63e",
	"./LMS_LOGO_new.png": "aae1",
	"./MangoSTEEMS_logo.png": "e3d6",
	"./bg-login-s.png": "73ba",
	"./bg-login-s2.png": "8d05",
	"./bg-login-s3.png": "281c",
	"./logo_dark.png": "7899",
	"./logo_light.png": "a4aa",
	"./m_icon.png": "a807",
	"./teacher.png": "4335",
	"./teacher_men.png": "4968",
	"./teacher_men_40.png": "03ea",
	"./teacher_women.png": "4550",
	"./teacher_women_40.png": "2d73",
	"./temp_logo.png": "ff45",
	"./user.png": "b494",
	"./user01.png": "2dae",
	"./user02.png": "6b62",
	"./user03.png": "c435",
	"./user04.png": "f987",
	"./user05.png": "3525",
	"./user06.png": "8f19",
	"./user07.png": "7d46",
	"./user08.png": "7bda",
	"./user09.png": "9a9e",
	"./user10.png": "bc3b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "34d1";